export const MuiTheme = {
  Mode: {
    Bright: 'bright',
    Dark: 'dark',
  },
} as const
